<template>
    <div class="vue timparty-carousel-basic banners-carousel" v-if="slides.length > 0">
        <LoaderOverlay v-if="loading"/>

        <div
          class="paragraph-carousel-container"
          :class="{'paragraph-carousel-container-padding' : footermsg !== ''}"
        >
            <div class="paragraph-carousel-controls" v-if="slides.length > 1" :data-slides-count="slides.length ">
                <div>
                    <a href="#" @click.prevent="sliderGoto('prev')" class="d-block"><img :src="themePath('/images/arrow-left.svg')"></a>
                    <a href="#" @click.prevent="sliderGoto()" class="d-block"><img :src="themePath('/images/arrow-right.svg')"></a>
                </div>
            </div>

            <div class="container">
                <div class="carousel-basic-slider paragraph-carousel">
                    <div class="paragraph-carousel-slide"  v-for="(slide,idx) in slides" v-bind:key="idx">
                        <div class="row row-eq-height no-gutters">

                            <div class="col-md-6 " >
                                <div class="slide slide-image">
                                    <img :src="slide.image" :alt="slide.title" class="img-fluid">
                                </div>
                            </div>
                            <div class="col-md-6 d-flex align-items-center">
                                <div class="mx-0 px-3 py-4">
                                    <div class="d-flex">
                                        <div>
                                            <h3 v-html="slide.title" class="text-black"></h3>
                                            <div class="mt-4 text-black" v-if="slide.content" v-html="slide.content"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="paragraph-carousel-footer">
                <div class="container">
                    <div class="paragraph-carousel-dots"></div>

                    <div v-if="footermsg !== ''" v-html="formattedFooterMessage" class="paragraph-carousel-highlight text-center">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import RewardsCard from './RewardsCard.vue'
import $ from 'jquery';
import 'slick-carousel';

export default {
    name: 'Carouselbasic',
    mixins: [TimPartyMixin],
    components: {LoaderOverlay, RewardsCard},
    props: {

        slides: {
            type: Array,
            required: true,

        },
        footermsg: {
            type: String,
            required: false,
            default: ''
        }

    },
    data: function () {
        return {

        };
    },
    mounted: function () {
        var self = this;
        if(this.slides.length > 0)
            this.activateSlider();
        $(document).ready(function() {
          if($('body').find('u[data-slide]').length > 0) {
            self.activateAnchors();
          }
        });


    },
    methods: {
        // data-slick='{"slidesToShow": 1, "slidesToScroll": 1, "dots": true, "infinite": true, "appendDots": ".paragraph-carousel-dots"}'
        activateSlider: function () {
            this.$nextTick( function() {
                $('.carousel-basic-slider').slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    appendDots: '.paragraph-carousel-dots',

                    responsive: [

                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false,
                    //
                            }
                        },
                        {
                            breakpoint: 520,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: false,
                            }
                        }
                    ]

                });
            });
        },
        activateAnchors: function() {
          $('u[data-slide]').click(function(e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop: $(".carousel-basic-slider").offset().top-$('#page').find('nav.navbar').height()
            }, 500);
            var slideno = $(this).data('slide');
            $('.carousel-basic-slider').slick('slickGoTo', slideno - 1);

          });
        },

        sliderGoto: function(dir){

          if(dir == 'prev'){
            $('.carousel-basic-slider').slick('slickPrev');
          }
          else{
            $('.carousel-basic-slider').slick('slickNext');
          }

        },


    },
    computed: {
      formattedFooterMessage () {
        return '<span>' + this.footermsg + '</span>';
      }
    },

}
</script>


